// Generated from ./util_cohort_builder_grammar/stable/StringAttributesLexer.g4 by ANTLR 4.13.1

import * as antlr from "antlr4ng";
import { Token } from "antlr4ng";


export class StringAttributesLexer extends antlr.Lexer {
    public static readonly COMMON_STRING_ATTRIBUTE = 1;
    public static readonly GENDER_SOURCE_VALUE = 2;
    public static readonly CARE_SITE_STRING_ATTRIBUTE = 3;
    public static readonly CONDITION_OCCURRENCE_STRING_ATTRIBUTE = 4;
    public static readonly DRUG_EXPOSURE_STRING_ATTRIBUTE = 5;
    public static readonly MEASUREMENT_STRING_ATTRIBUTE = 6;
    public static readonly OBSERVATION_STRING_ATTRIBUTE = 7;
    public static readonly PERSON_STRING_ATTRIBUTE = 8;
    public static readonly PROCEDURE_OCCURRENCE_STRING_ATTRIBUTE = 9;
    public static readonly PROVIDER_STRING_ATTRIBUTE = 10;
    public static readonly VISIT_OCCURRENCE_STRING_ATTRIBUTE = 11;

    public static readonly channelNames = [
        "DEFAULT_TOKEN_CHANNEL", "HIDDEN"
    ];

    public static readonly literalNames = [
        null, "'value_as_string'", "'gender_source_value'"
    ];

    public static readonly symbolicNames = [
        null, "COMMON_STRING_ATTRIBUTE", "GENDER_SOURCE_VALUE", "CARE_SITE_STRING_ATTRIBUTE", 
        "CONDITION_OCCURRENCE_STRING_ATTRIBUTE", "DRUG_EXPOSURE_STRING_ATTRIBUTE", 
        "MEASUREMENT_STRING_ATTRIBUTE", "OBSERVATION_STRING_ATTRIBUTE", 
        "PERSON_STRING_ATTRIBUTE", "PROCEDURE_OCCURRENCE_STRING_ATTRIBUTE", 
        "PROVIDER_STRING_ATTRIBUTE", "VISIT_OCCURRENCE_STRING_ATTRIBUTE"
    ];

    public static readonly modeNames = [
        "DEFAULT_MODE",
    ];

    public static readonly ruleNames = [
        "COMMON_STRING_ATTRIBUTE", "GENDER_SOURCE_VALUE", "CARE_SITE_STRING_ATTRIBUTE", 
        "CONDITION_OCCURRENCE_STRING_ATTRIBUTE", "DRUG_EXPOSURE_STRING_ATTRIBUTE", 
        "MEASUREMENT_STRING_ATTRIBUTE", "OBSERVATION_STRING_ATTRIBUTE", 
        "PERSON_STRING_ATTRIBUTE", "PROCEDURE_OCCURRENCE_STRING_ATTRIBUTE", 
        "PROVIDER_STRING_ATTRIBUTE", "VISIT_OCCURRENCE_STRING_ATTRIBUTE",
    ];


    public constructor(input: antlr.CharStream) {
        super(input);
        this.interpreter = new antlr.LexerATNSimulator(this, StringAttributesLexer._ATN, StringAttributesLexer.decisionsToDFA, new antlr.PredictionContextCache());
    }

    public get grammarFileName(): string { return "StringAttributesLexer.g4"; }

    public get literalNames(): (string | null)[] { return StringAttributesLexer.literalNames; }
    public get symbolicNames(): (string | null)[] { return StringAttributesLexer.symbolicNames; }
    public get ruleNames(): string[] { return StringAttributesLexer.ruleNames; }

    public get serializedATN(): number[] { return StringAttributesLexer._serializedATN; }

    public get channelNames(): string[] { return StringAttributesLexer.channelNames; }

    public get modeNames(): string[] { return StringAttributesLexer.modeNames; }

    public static readonly _serializedATN: number[] = [
        4,0,11,630,6,-1,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,5,
        2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,1,0,1,0,1,0,1,0,1,0,1,
        0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,1,1,1,1,1,1,1,1,1,1,
        1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,
        2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,
        2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,
        2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,
        2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,3,
        2,125,8,2,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,
        3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,
        3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,
        3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,
        3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,
        3,1,3,1,3,1,3,1,3,1,3,3,3,210,8,3,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,
        4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,
        4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,
        4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,
        4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,
        4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,
        4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,3,4,307,8,4,1,5,1,5,1,5,1,5,1,5,1,
        5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,
        5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,
        5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,
        5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,
        5,1,5,1,5,1,5,1,5,1,5,3,5,384,8,5,1,6,1,6,1,7,1,7,1,7,1,7,1,7,1,
        7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,
        7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,
        7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,
        7,1,7,1,7,1,7,1,7,1,7,3,7,447,8,7,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,
        8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,
        8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,
        8,1,8,1,8,1,8,3,8,492,8,8,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,
        9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,
        9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,
        9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,
        9,1,9,1,9,1,9,1,9,1,9,3,9,557,8,9,1,10,1,10,1,10,1,10,1,10,1,10,
        1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,
        1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,
        1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,
        1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,
        1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,3,10,
        629,8,10,0,0,11,1,1,3,2,5,3,7,4,9,5,11,6,13,7,15,8,17,9,19,10,21,
        11,1,0,0,652,0,1,1,0,0,0,0,3,1,0,0,0,0,5,1,0,0,0,0,7,1,0,0,0,0,9,
        1,0,0,0,0,11,1,0,0,0,0,13,1,0,0,0,0,15,1,0,0,0,0,17,1,0,0,0,0,19,
        1,0,0,0,0,21,1,0,0,0,1,23,1,0,0,0,3,39,1,0,0,0,5,124,1,0,0,0,7,209,
        1,0,0,0,9,306,1,0,0,0,11,383,1,0,0,0,13,385,1,0,0,0,15,446,1,0,0,
        0,17,491,1,0,0,0,19,556,1,0,0,0,21,628,1,0,0,0,23,24,5,118,0,0,24,
        25,5,97,0,0,25,26,5,108,0,0,26,27,5,117,0,0,27,28,5,101,0,0,28,29,
        5,95,0,0,29,30,5,97,0,0,30,31,5,115,0,0,31,32,5,95,0,0,32,33,5,115,
        0,0,33,34,5,116,0,0,34,35,5,114,0,0,35,36,5,105,0,0,36,37,5,110,
        0,0,37,38,5,103,0,0,38,2,1,0,0,0,39,40,5,103,0,0,40,41,5,101,0,0,
        41,42,5,110,0,0,42,43,5,100,0,0,43,44,5,101,0,0,44,45,5,114,0,0,
        45,46,5,95,0,0,46,47,5,115,0,0,47,48,5,111,0,0,48,49,5,117,0,0,49,
        50,5,114,0,0,50,51,5,99,0,0,51,52,5,101,0,0,52,53,5,95,0,0,53,54,
        5,118,0,0,54,55,5,97,0,0,55,56,5,108,0,0,56,57,5,117,0,0,57,58,5,
        101,0,0,58,4,1,0,0,0,59,60,5,99,0,0,60,61,5,97,0,0,61,62,5,114,0,
        0,62,63,5,101,0,0,63,64,5,95,0,0,64,65,5,115,0,0,65,66,5,105,0,0,
        66,67,5,116,0,0,67,68,5,101,0,0,68,69,5,95,0,0,69,70,5,110,0,0,70,
        71,5,97,0,0,71,72,5,109,0,0,72,125,5,101,0,0,73,74,5,99,0,0,74,75,
        5,97,0,0,75,76,5,114,0,0,76,77,5,101,0,0,77,78,5,95,0,0,78,79,5,
        115,0,0,79,80,5,105,0,0,80,81,5,116,0,0,81,82,5,101,0,0,82,83,5,
        95,0,0,83,84,5,115,0,0,84,85,5,111,0,0,85,86,5,117,0,0,86,87,5,114,
        0,0,87,88,5,99,0,0,88,89,5,101,0,0,89,90,5,95,0,0,90,91,5,118,0,
        0,91,92,5,97,0,0,92,93,5,108,0,0,93,94,5,117,0,0,94,125,5,101,0,
        0,95,96,5,112,0,0,96,97,5,108,0,0,97,98,5,97,0,0,98,99,5,99,0,0,
        99,100,5,101,0,0,100,101,5,95,0,0,101,102,5,111,0,0,102,103,5,102,
        0,0,103,104,5,95,0,0,104,105,5,115,0,0,105,106,5,101,0,0,106,107,
        5,114,0,0,107,108,5,118,0,0,108,109,5,105,0,0,109,110,5,99,0,0,110,
        111,5,101,0,0,111,112,5,95,0,0,112,113,5,115,0,0,113,114,5,111,0,
        0,114,115,5,117,0,0,115,116,5,114,0,0,116,117,5,99,0,0,117,118,5,
        101,0,0,118,119,5,95,0,0,119,120,5,118,0,0,120,121,5,97,0,0,121,
        122,5,108,0,0,122,123,5,117,0,0,123,125,5,101,0,0,124,59,1,0,0,0,
        124,73,1,0,0,0,124,95,1,0,0,0,125,6,1,0,0,0,126,127,5,99,0,0,127,
        128,5,111,0,0,128,129,5,110,0,0,129,130,5,100,0,0,130,131,5,105,
        0,0,131,132,5,116,0,0,132,133,5,105,0,0,133,134,5,111,0,0,134,135,
        5,110,0,0,135,136,5,95,0,0,136,137,5,111,0,0,137,138,5,99,0,0,138,
        139,5,99,0,0,139,140,5,117,0,0,140,141,5,114,0,0,141,142,5,114,0,
        0,142,143,5,101,0,0,143,144,5,110,0,0,144,145,5,99,0,0,145,146,5,
        101,0,0,146,147,5,95,0,0,147,148,5,115,0,0,148,149,5,116,0,0,149,
        150,5,111,0,0,150,151,5,112,0,0,151,152,5,95,0,0,152,153,5,114,0,
        0,153,154,5,101,0,0,154,155,5,97,0,0,155,156,5,115,0,0,156,157,5,
        111,0,0,157,210,5,110,0,0,158,159,5,99,0,0,159,160,5,111,0,0,160,
        161,5,110,0,0,161,162,5,100,0,0,162,163,5,105,0,0,163,164,5,116,
        0,0,164,165,5,105,0,0,165,166,5,111,0,0,166,167,5,110,0,0,167,168,
        5,95,0,0,168,169,5,115,0,0,169,170,5,111,0,0,170,171,5,117,0,0,171,
        172,5,114,0,0,172,173,5,99,0,0,173,174,5,101,0,0,174,175,5,95,0,
        0,175,176,5,118,0,0,176,177,5,97,0,0,177,178,5,108,0,0,178,179,5,
        117,0,0,179,210,5,101,0,0,180,181,5,99,0,0,181,182,5,111,0,0,182,
        183,5,110,0,0,183,184,5,100,0,0,184,185,5,105,0,0,185,186,5,116,
        0,0,186,187,5,105,0,0,187,188,5,111,0,0,188,189,5,110,0,0,189,190,
        5,95,0,0,190,191,5,115,0,0,191,192,5,116,0,0,192,193,5,97,0,0,193,
        194,5,116,0,0,194,195,5,117,0,0,195,196,5,115,0,0,196,197,5,95,0,
        0,197,198,5,115,0,0,198,199,5,111,0,0,199,200,5,117,0,0,200,201,
        5,114,0,0,201,202,5,99,0,0,202,203,5,101,0,0,203,204,5,95,0,0,204,
        205,5,118,0,0,205,206,5,97,0,0,206,207,5,108,0,0,207,208,5,117,0,
        0,208,210,5,101,0,0,209,126,1,0,0,0,209,158,1,0,0,0,209,180,1,0,
        0,0,210,8,1,0,0,0,211,212,5,100,0,0,212,213,5,114,0,0,213,214,5,
        117,0,0,214,215,5,103,0,0,215,216,5,95,0,0,216,217,5,101,0,0,217,
        218,5,120,0,0,218,219,5,112,0,0,219,220,5,111,0,0,220,221,5,115,
        0,0,221,222,5,117,0,0,222,223,5,114,0,0,223,224,5,101,0,0,224,225,
        5,95,0,0,225,226,5,115,0,0,226,227,5,116,0,0,227,228,5,111,0,0,228,
        229,5,112,0,0,229,230,5,95,0,0,230,231,5,114,0,0,231,232,5,101,0,
        0,232,233,5,97,0,0,233,234,5,115,0,0,234,235,5,111,0,0,235,307,5,
        110,0,0,236,237,5,115,0,0,237,238,5,105,0,0,238,307,5,103,0,0,239,
        240,5,108,0,0,240,241,5,111,0,0,241,242,5,116,0,0,242,243,5,95,0,
        0,243,244,5,110,0,0,244,245,5,117,0,0,245,246,5,109,0,0,246,247,
        5,98,0,0,247,248,5,101,0,0,248,307,5,114,0,0,249,250,5,100,0,0,250,
        251,5,114,0,0,251,252,5,117,0,0,252,253,5,103,0,0,253,254,5,95,0,
        0,254,255,5,115,0,0,255,256,5,111,0,0,256,257,5,117,0,0,257,258,
        5,114,0,0,258,259,5,99,0,0,259,260,5,101,0,0,260,261,5,95,0,0,261,
        262,5,118,0,0,262,263,5,97,0,0,263,264,5,108,0,0,264,265,5,117,0,
        0,265,307,5,101,0,0,266,267,5,114,0,0,267,268,5,111,0,0,268,269,
        5,117,0,0,269,270,5,116,0,0,270,271,5,101,0,0,271,272,5,95,0,0,272,
        273,5,115,0,0,273,274,5,111,0,0,274,275,5,117,0,0,275,276,5,114,
        0,0,276,277,5,99,0,0,277,278,5,101,0,0,278,279,5,95,0,0,279,280,
        5,118,0,0,280,281,5,97,0,0,281,282,5,108,0,0,282,283,5,117,0,0,283,
        307,5,101,0,0,284,285,5,100,0,0,285,286,5,111,0,0,286,287,5,115,
        0,0,287,288,5,101,0,0,288,289,5,95,0,0,289,290,5,117,0,0,290,291,
        5,110,0,0,291,292,5,105,0,0,292,293,5,116,0,0,293,294,5,95,0,0,294,
        295,5,115,0,0,295,296,5,111,0,0,296,297,5,117,0,0,297,298,5,114,
        0,0,298,299,5,99,0,0,299,300,5,101,0,0,300,301,5,95,0,0,301,302,
        5,118,0,0,302,303,5,97,0,0,303,304,5,108,0,0,304,305,5,117,0,0,305,
        307,5,101,0,0,306,211,1,0,0,0,306,236,1,0,0,0,306,239,1,0,0,0,306,
        249,1,0,0,0,306,266,1,0,0,0,306,284,1,0,0,0,307,10,1,0,0,0,308,309,
        5,109,0,0,309,310,5,101,0,0,310,311,5,97,0,0,311,312,5,115,0,0,312,
        313,5,117,0,0,313,314,5,114,0,0,314,315,5,101,0,0,315,316,5,109,
        0,0,316,317,5,101,0,0,317,318,5,110,0,0,318,319,5,116,0,0,319,320,
        5,95,0,0,320,321,5,116,0,0,321,322,5,105,0,0,322,323,5,109,0,0,323,
        384,5,101,0,0,324,325,5,109,0,0,325,326,5,101,0,0,326,327,5,97,0,
        0,327,328,5,115,0,0,328,329,5,117,0,0,329,330,5,114,0,0,330,331,
        5,101,0,0,331,332,5,109,0,0,332,333,5,101,0,0,333,334,5,110,0,0,
        334,335,5,116,0,0,335,336,5,95,0,0,336,337,5,115,0,0,337,338,5,111,
        0,0,338,339,5,117,0,0,339,340,5,114,0,0,340,341,5,99,0,0,341,342,
        5,101,0,0,342,343,5,95,0,0,343,344,5,118,0,0,344,345,5,97,0,0,345,
        346,5,108,0,0,346,347,5,117,0,0,347,384,5,101,0,0,348,349,5,117,
        0,0,349,350,5,110,0,0,350,351,5,105,0,0,351,352,5,116,0,0,352,353,
        5,95,0,0,353,354,5,115,0,0,354,355,5,111,0,0,355,356,5,117,0,0,356,
        357,5,114,0,0,357,358,5,99,0,0,358,359,5,101,0,0,359,360,5,95,0,
        0,360,361,5,118,0,0,361,362,5,97,0,0,362,363,5,108,0,0,363,364,5,
        117,0,0,364,384,5,101,0,0,365,366,5,118,0,0,366,367,5,97,0,0,367,
        368,5,108,0,0,368,369,5,117,0,0,369,370,5,101,0,0,370,371,5,95,0,
        0,371,372,5,115,0,0,372,373,5,111,0,0,373,374,5,117,0,0,374,375,
        5,114,0,0,375,376,5,99,0,0,376,377,5,101,0,0,377,378,5,95,0,0,378,
        379,5,118,0,0,379,380,5,97,0,0,380,381,5,108,0,0,381,382,5,117,0,
        0,382,384,5,101,0,0,383,308,1,0,0,0,383,324,1,0,0,0,383,348,1,0,
        0,0,383,365,1,0,0,0,384,12,1,0,0,0,385,386,3,1,0,0,386,14,1,0,0,
        0,387,388,5,112,0,0,388,389,5,101,0,0,389,390,5,114,0,0,390,391,
        5,115,0,0,391,392,5,111,0,0,392,393,5,110,0,0,393,394,5,95,0,0,394,
        395,5,115,0,0,395,396,5,111,0,0,396,397,5,117,0,0,397,398,5,114,
        0,0,398,399,5,99,0,0,399,400,5,101,0,0,400,401,5,95,0,0,401,402,
        5,118,0,0,402,403,5,97,0,0,403,404,5,108,0,0,404,405,5,117,0,0,405,
        447,5,101,0,0,406,447,3,3,1,0,407,408,5,114,0,0,408,409,5,97,0,0,
        409,410,5,99,0,0,410,411,5,101,0,0,411,412,5,95,0,0,412,413,5,115,
        0,0,413,414,5,111,0,0,414,415,5,117,0,0,415,416,5,114,0,0,416,417,
        5,99,0,0,417,418,5,101,0,0,418,419,5,95,0,0,419,420,5,118,0,0,420,
        421,5,97,0,0,421,422,5,108,0,0,422,423,5,117,0,0,423,447,5,101,0,
        0,424,425,5,101,0,0,425,426,5,116,0,0,426,427,5,104,0,0,427,428,
        5,110,0,0,428,429,5,105,0,0,429,430,5,99,0,0,430,431,5,105,0,0,431,
        432,5,116,0,0,432,433,5,121,0,0,433,434,5,95,0,0,434,435,5,115,0,
        0,435,436,5,111,0,0,436,437,5,117,0,0,437,438,5,114,0,0,438,439,
        5,99,0,0,439,440,5,101,0,0,440,441,5,95,0,0,441,442,5,118,0,0,442,
        443,5,97,0,0,443,444,5,108,0,0,444,445,5,117,0,0,445,447,5,101,0,
        0,446,387,1,0,0,0,446,406,1,0,0,0,446,407,1,0,0,0,446,424,1,0,0,
        0,447,16,1,0,0,0,448,449,5,112,0,0,449,450,5,114,0,0,450,451,5,111,
        0,0,451,452,5,99,0,0,452,453,5,101,0,0,453,454,5,100,0,0,454,455,
        5,117,0,0,455,456,5,114,0,0,456,457,5,101,0,0,457,458,5,95,0,0,458,
        459,5,115,0,0,459,460,5,111,0,0,460,461,5,117,0,0,461,462,5,114,
        0,0,462,463,5,99,0,0,463,464,5,101,0,0,464,465,5,95,0,0,465,466,
        5,118,0,0,466,467,5,97,0,0,467,468,5,108,0,0,468,469,5,117,0,0,469,
        492,5,101,0,0,470,471,5,109,0,0,471,472,5,111,0,0,472,473,5,100,
        0,0,473,474,5,105,0,0,474,475,5,102,0,0,475,476,5,105,0,0,476,477,
        5,101,0,0,477,478,5,114,0,0,478,479,5,95,0,0,479,480,5,115,0,0,480,
        481,5,111,0,0,481,482,5,117,0,0,482,483,5,114,0,0,483,484,5,99,0,
        0,484,485,5,101,0,0,485,486,5,95,0,0,486,487,5,118,0,0,487,488,5,
        97,0,0,488,489,5,108,0,0,489,490,5,117,0,0,490,492,5,101,0,0,491,
        448,1,0,0,0,491,470,1,0,0,0,492,18,1,0,0,0,493,494,5,112,0,0,494,
        495,5,114,0,0,495,496,5,111,0,0,496,497,5,118,0,0,497,498,5,105,
        0,0,498,499,5,100,0,0,499,500,5,101,0,0,500,501,5,114,0,0,501,502,
        5,95,0,0,502,503,5,110,0,0,503,504,5,97,0,0,504,505,5,109,0,0,505,
        557,5,101,0,0,506,507,5,110,0,0,507,508,5,112,0,0,508,557,5,105,
        0,0,509,510,5,100,0,0,510,511,5,101,0,0,511,557,5,97,0,0,512,513,
        5,112,0,0,513,514,5,114,0,0,514,515,5,111,0,0,515,516,5,118,0,0,
        516,517,5,105,0,0,517,518,5,100,0,0,518,519,5,101,0,0,519,520,5,
        114,0,0,520,521,5,95,0,0,521,522,5,115,0,0,522,523,5,111,0,0,523,
        524,5,117,0,0,524,525,5,114,0,0,525,526,5,99,0,0,526,527,5,101,0,
        0,527,528,5,95,0,0,528,529,5,118,0,0,529,530,5,97,0,0,530,531,5,
        108,0,0,531,532,5,117,0,0,532,557,5,101,0,0,533,534,5,115,0,0,534,
        535,5,112,0,0,535,536,5,101,0,0,536,537,5,99,0,0,537,538,5,105,0,
        0,538,539,5,97,0,0,539,540,5,108,0,0,540,541,5,116,0,0,541,542,5,
        121,0,0,542,543,5,95,0,0,543,544,5,115,0,0,544,545,5,111,0,0,545,
        546,5,117,0,0,546,547,5,114,0,0,547,548,5,99,0,0,548,549,5,101,0,
        0,549,550,5,95,0,0,550,551,5,118,0,0,551,552,5,97,0,0,552,553,5,
        108,0,0,553,554,5,117,0,0,554,557,5,101,0,0,555,557,3,3,1,0,556,
        493,1,0,0,0,556,506,1,0,0,0,556,509,1,0,0,0,556,512,1,0,0,0,556,
        533,1,0,0,0,556,555,1,0,0,0,557,20,1,0,0,0,558,559,5,118,0,0,559,
        560,5,105,0,0,560,561,5,115,0,0,561,562,5,105,0,0,562,563,5,116,
        0,0,563,564,5,95,0,0,564,565,5,115,0,0,565,566,5,111,0,0,566,567,
        5,117,0,0,567,568,5,114,0,0,568,569,5,99,0,0,569,570,5,101,0,0,570,
        571,5,95,0,0,571,572,5,118,0,0,572,573,5,97,0,0,573,574,5,108,0,
        0,574,575,5,117,0,0,575,629,5,101,0,0,576,577,5,97,0,0,577,578,5,
        100,0,0,578,579,5,109,0,0,579,580,5,105,0,0,580,581,5,116,0,0,581,
        582,5,116,0,0,582,583,5,101,0,0,583,584,5,100,0,0,584,585,5,95,0,
        0,585,586,5,102,0,0,586,587,5,114,0,0,587,588,5,111,0,0,588,589,
        5,109,0,0,589,590,5,95,0,0,590,591,5,115,0,0,591,592,5,111,0,0,592,
        593,5,117,0,0,593,594,5,114,0,0,594,595,5,99,0,0,595,596,5,101,0,
        0,596,597,5,95,0,0,597,598,5,118,0,0,598,599,5,97,0,0,599,600,5,
        108,0,0,600,601,5,117,0,0,601,629,5,101,0,0,602,603,5,100,0,0,603,
        604,5,105,0,0,604,605,5,115,0,0,605,606,5,99,0,0,606,607,5,104,0,
        0,607,608,5,97,0,0,608,609,5,114,0,0,609,610,5,103,0,0,610,611,5,
        101,0,0,611,612,5,100,0,0,612,613,5,95,0,0,613,614,5,116,0,0,614,
        615,5,111,0,0,615,616,5,95,0,0,616,617,5,115,0,0,617,618,5,111,0,
        0,618,619,5,117,0,0,619,620,5,114,0,0,620,621,5,99,0,0,621,622,5,
        101,0,0,622,623,5,95,0,0,623,624,5,118,0,0,624,625,5,97,0,0,625,
        626,5,108,0,0,626,627,5,117,0,0,627,629,5,101,0,0,628,558,1,0,0,
        0,628,576,1,0,0,0,628,602,1,0,0,0,629,22,1,0,0,0,9,0,124,209,306,
        383,446,491,556,628,0
    ];

    private static __ATN: antlr.ATN;
    public static get _ATN(): antlr.ATN {
        if (!StringAttributesLexer.__ATN) {
            StringAttributesLexer.__ATN = new antlr.ATNDeserializer().deserialize(StringAttributesLexer._serializedATN);
        }

        return StringAttributesLexer.__ATN;
    }


    private static readonly vocabulary = new antlr.Vocabulary(StringAttributesLexer.literalNames, StringAttributesLexer.symbolicNames, []);

    public override get vocabulary(): antlr.Vocabulary {
        return StringAttributesLexer.vocabulary;
    }

    private static readonly decisionsToDFA = StringAttributesLexer._ATN.decisionToState.map( (ds: antlr.DecisionState, index: number) => new antlr.DFA(ds, index) );
}